import { useGSAP } from "@gsap/react";
import styled from "@emotion/styled";
import gsap from "gsap";
import VideoCarousel from "./VideoCarousel/VideoCarousel";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";

const ContainerSection = styled.section`
  /* Base */
  overflow-x: hidden;
  width: 100vw;
  height: 100%;
`;

const TestHighlights = () => {
  useGSAP(() => {
    gsap.to("#heading-slider-1", { opacity: 1, y: 0 });
    gsap.to(".link", { opacity: 1, y: 0, duration: 1, stagger: 0.25 });
  }, []);

  return (
    <ContainerSection id="highlights" className="t-ptb-10">
      <div className="t-container">
        <Shared02Headings
          options={{
            section_id: "s-heading-high",
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              "max-width": "100rem",
              "margin-bottom": "6rem",
            },
            container_desktop_styles: {},
            obj_heading: {
              text_id: "main-heading",
              main_text:
                "A Better Way to <span class='t-enlace'>Learn Bachata</span>",
              main_tag_version: "h2",
              main_text_css: "t-h-1",
              heading_mobile_styles: {
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: {
              text_id: "support-heading",
              main_text:
                "A clear learning path designed to help you progress with confidence, not confusion",
              main_tag_version: "h3",
              main_text_css: "h4",
              heading_mobile_styles: {
                color: "#fff",
                "font-weight": "700",
                "margin-bottom": "1rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },

            obj_divider: {
              divider_id: "divider",
              divider_mobile_styles: {
                width: "70%",
                background:
                  "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: false,
            obj_buttons: false,
            heading_version: "heading_01",
          }}
        />
        <VideoCarousel />
      </div>
    </ContainerSection>
  );
};

export default TestHighlights;
